import { Controller } from '@hotwired/stimulus';

/**
 * Toggles the Groep navigation and its accessible state.
 */
export default class extends Controller {
  /**
   * @type {string[]}
   */
  static targets = ['menu', 'button'];

  /**
   * Toggle the main navigation.
   */
  toggle() {
    this.menuTarget.hidden = !this.menuTarget.hidden;
    this.buttonTarget.setAttribute('aria-expanded', (!this.menuTarget.hidden).toString());
    this.element.classList.toggle('menu-is-open', !this.menuTarget.hidden);
  }

  /**
   * Close the navigation and restore focus to its button.
   */
  close() {
    if (!this.menuTarget.hidden) {
      this.toggle();
      this.buttonTarget.focus();
    }
  }
}
